import { render, staticRenderFns } from "./ItemSucursales.vue?vue&type=template&id=0e020f02&"
import script from "./ItemSucursales.vue?vue&type=script&lang=js&"
export * from "./ItemSucursales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports